import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { nanoid } from 'nanoid';
import { trailBackSlash } from '../../utils/url';
import { getWindowParams, checkPushAllowed } from '../../utils/window';
import { validateOrigin } from '../../utils/message';
import { EMessageRequestTypes, EWindowStaticMethods } from '../../types';
import { getReadyHandler } from './helpers';
export var IFRAME_ID = 'cian-pushworker-iframe';
export var POPUP_TITLE = 'Разрешить получение уведомлений на ЦИАН';
export var IFRAME_STYLE = 'width:0;height:0;border:0; border:none;';
var POPUP_WIDTH = 50;
var POPUP_HEIGHT = 50;
var RESPONSE_TIMEOUT = 5000;
export var PushManager = /*#__PURE__*/function () {
  /**
   * Класс, инкапсулирующий логику работы с пушами на страницах сайта
   * @constructor
   * @param {string} baseUrl - url микросервиса веб пушей.
   */
  function PushManager(props) {
    var _this = this;

    _classCallCheck(this, PushManager);

    _defineProperty(this, "baseUrl", void 0);

    _defineProperty(this, "hasSubdomain", void 0);

    _defineProperty(this, "iframe", null);

    _defineProperty(this, "popup", null);

    _defineProperty(this, "callbacks", void 0);

    _defineProperty(this, "handleMessage", function (event) {
      if (event.data) {
        var messageResponse;

        try {
          messageResponse = JSON.parse(event.data);
        } catch (e) {
          return;
        }

        if (!validateOrigin(event.origin)) {
          return;
        }

        var cbId = messageResponse.id || messageResponse.type;
        var cb = _this.callbacks[cbId];

        if (cb) {
          cb(messageResponse.value);
        }
      }
    });

    _defineProperty(this, "registerMessageCallback", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cbId) {
        var cbPromise, timeoutPromise, value;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                cbPromise = new Promise(function (resolve) {
                  _this.callbacks[cbId] = function (data) {
                    resolve(data);
                  };
                });
                timeoutPromise = new Promise(function (_, reject) {
                  setTimeout(function () {
                    reject("Message ".concat(cbId, " timeout error"));
                  }, RESPONSE_TIMEOUT);
                });
                _context.prev = 2;
                _context.next = 5;
                return Promise.race([cbPromise, timeoutPromise]);

              case 5:
                value = _context.sent;
                return _context.abrupt("return", value);

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);
                throw _context.t0;

              case 12:
                _context.prev = 12;

                _this.removeCallback(cbId);

                return _context.finish(12);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 9, 12, 15]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(this, "postMessage", function (type, value) {
      var iframe = _this.iframe || document.getElementById(IFRAME_ID);

      if (iframe && iframe.contentWindow) {
        var messageId = nanoid();
        var message = {
          id: messageId,
          type: type,
          value: value
        };

        var promise = _this.registerMessageCallback(messageId);

        iframe.contentWindow.postMessage(JSON.stringify(message), _this.baseUrl);
        return promise;
      }

      return Promise.reject('Unable to send message');
    });

    _defineProperty(this, "registerWorker", function () {
      if (!_this.iframe) {
        _this.iframe = document.createElement('iframe');

        _this.iframe.setAttribute('id', IFRAME_ID);

        _this.iframe.src = "".concat(_this.baseUrl, "/web-push-subscribe-iframe");
        _this.iframe.frameBorder = '0';
        _this.iframe.scrolling = 'no';

        _this.iframe.setAttribute('style', IFRAME_STYLE);

        document.body.appendChild(_this.iframe);
        window.addEventListener('message', _this.handleMessage);
      }
    });

    _defineProperty(this, "checkSubscription", function () {
      return _this.postMessage(EMessageRequestTypes.getSubscription);
    });

    this.baseUrl = trailBackSlash(props.baseUrl);
    this.callbacks = {}; // this.isPushAllowed = checkPushAllowed();

    PushManager.ready();

    if (props.hasSubdomain) {
      this.registerWorker();
    }

    window[EWindowStaticMethods.checkSubsciption] = this.checkSubscription;
  }
  /**
   * При использовании пушей в каком-либо микросервисе необходимо вызывать этот метод
   * и все действия типа проверки на подписки на пуши делать только после разрешения промиса, который
   * функция возвращает.
   * @returns {Promise<void>} В случае успешной регистрации воркера попадаем в then, иначе в catch
   */


  _createClass(PushManager, [{
    key: "removeCallback",
    value:
    /**
     * Удаляет обработчик сообщения
     * @param {event} cbId Идентификатор колбека.
     * @returns {void}
     */
    function removeCallback(cbId) {
      this.callbacks[cbId] = null;
      delete this.callbacks[cbId];
    }
    /**
     * Отправляет сообщение в окно айфрейма с воркером
     * @param {type} EMessageRequestTypes Тип сообщения.
     * @param {value} TMessageRequestValueTypes Данные для отправки.
     * @returns {Promise<TMessageResponseValueTypes>} Promise, который разрешается в результат ответа
     */

  }, {
    key: "showPopup",
    value:
    /**
     * Показывает попвп, в котором пользователя спрашивают разрешение на получение пушей
     * и в случае успеха производится подписка
     * @param {params} IWindowOpenParams Параметры открываемого окна.
     * @returns {Promise<null, IMessageResponse>} Promise, который разрешается в результат регистрации воркера
     */
    function showPopup(params) {
      if (checkPushAllowed()) {
        var _params$width = params.width,
            width = _params$width === void 0 ? POPUP_WIDTH : _params$width,
            _params$height = params.height,
            height = _params$height === void 0 ? POPUP_HEIGHT : _params$height,
            _params$resizable = params.resizable,
            resizable = _params$resizable === void 0 ? true : _params$resizable,
            _params$status = params.status,
            status = _params$status === void 0 ? true : _params$status,
            trackingLabel = params.trackingLabel;
        this.popup = window.open("".concat(this.baseUrl, "/web-push-subscribe-popup?label=").concat(trackingLabel), POPUP_TITLE, getWindowParams({
          width: width,
          height: height,
          resizable: resizable,
          status: status
        }));
      } else {
        throw new Error('Web push is not allowed');
      }
    }
    /**
     * Проверяет подписан ли пользователь на пуши
     * @param {params} IWindowOpenParams Параметры открываемого окна.
     * @returns {Promise<boolean>} Promise, который который резолвтися в boolean признак подписки
     */

  }], [{
    key: "ready",
    value: function ready() {
      if (window[EWindowStaticMethods.ready]) {
        return window[EWindowStaticMethods.ready];
      }

      var handler;
      var promise = new Promise(function (resolve, reject) {
        handler = getReadyHandler(resolve, reject);
        window.addEventListener('message', handler);
      }).then(function () {
        return window.removeEventListener('message', handler);
      });
      window[EWindowStaticMethods.ready] = promise;
      return promise;
    }
    /**
     * Статический метод для получения состояния подписки.
     @returns {Promise<boolean>}
     */

  }, {
    key: "checkSubscription",
    value: function () {
      var _checkSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return window[EWindowStaticMethods.ready];

              case 3:
                if (checkPushAllowed()) {
                  _context2.next = 5;
                  break;
                }

                throw new Error('Web push is not allowed');

              case 5:
                return _context2.abrupt("return", window[EWindowStaticMethods.checkSubsciption]());

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                throw new Error("Failed to check subscription: ".concat(_context2.t0));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 8]]);
      }));

      function checkSubscription() {
        return _checkSubscription.apply(this, arguments);
      }

      return checkSubscription;
    }()
    /**
     * Метод обрабатывает входящие сообщения.
     * @param {event} MessageEvent Объект события.
     * @returns {void}
     */

  }]);

  return PushManager;
}();